import Archives from '@/page/wholeasle/Archives';
import Sales from '@/page/wholeasle/sales';
import Return from '@/page/wholeasle/return';
import Query from '@/page/wholeasle/query';
import SalesAdd from '@/page/wholeasle/salesAdd';
import ReturnAdd from '@/page/wholeasle/ReturnAdd'
import detail from '@/components/template/detail'
import SalesDetail from '@/page/wholeasle/SalesDetail';
import wholeasleReturnDetail from '@/page/wholeasle/ReturnDetail';
import Profit from '@/page/wholeasle/Profit';

export const wholeasle = [{
  path: '/wholeasle/archives',
  name: 'archives',
  component: Archives,
  meta: {
    requireAuth: true,
    title: '批发客户'
  },
},
  {
    path: '/wholeasle/sales',
    name: 'sales',
    component: Sales,
    meta: {
      requireAuth: true,
      title: '批发销售单'
    },
  },
  {
    path: '/wholeasle/sales/add',
    name: 'SalesAdd',
    component: SalesAdd,
    meta: {
      requireAuth: true,
      title: '销售批发单'
    }
  },
  {
    path: '/wholeasle/sales/detail',
    name: 'SalesDetail',
    component: SalesDetail,
    meta: {
      requireAuth: true,
      title: '批发销售单详情'
    },
  },
  {
    path: '/wholeasle/return',
    name: 'return',
    component: Return,
    meta: {
      requireAuth: true,
      title: '批发退货单'
    },
  },
  {
    path: '/wholeasle/return/detail',
    name: 'wholeasleReturnDetail',
    component: wholeasleReturnDetail,
    meta: {
      requireAuth: true,
      title: '批发退货单详情'
    },
  },
  {
    path: '/wholeasle/return/add',
    name: 'ReturnAdd',
    component: ReturnAdd,
    meta: {
      requireAuth: true,
      title: '退货批发单'
    }
  },
  {
    path: '/wholeasle/query',
    name: 'query',
    component: Query,
    meta: {
      requireAuth: true,
      title: '批发汇总'
    },
  },
  {
    path: '/wholeasle/profit',
    name: 'Profit',
    component: Profit,
    meta: {
      requireAuth: true,
      title: '批发毛利'
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/wholeasle.route.js